import React from 'react';
import '../assets/css/bootstrap.min.css';
import '../assets/css/font-awesome.min.css';
import '../assets/css/fontawesome-stars-o.min.css';
import '../assets/css/responsive-style.css';
import '../assets/css/colors/theme-color-1.css';
import '../assets/css/custom.css';
import '../assets/css/home.css';
import '../assets/css/owl.carousel.min.css';

const About = () => {
  return (
    <div>
  {/* Posts Filter Bar Start */}
  <div className="posts--filter-bar style--1 hidden-xs">
    <div className="container">
      <ul className="nav">
        <li>
          <a href="#">
            <i className="fa fa-star-o" />
            <span>Featured News</span>
          </a>
        </li>
        <li>
          <a href="#">
            <i className="fa fa-heart-o" />
            <span>Most Popular</span>
          </a>
        </li>
        <li>
          <a href="#">
            <i className="fa fa-fire" />
            <span>Hot News</span>
          </a>
        </li>
        <li>
          <a href="#">
            <i className="fa fa-flash" />
            <span>Trending News</span>
          </a>
        </li>
        <li>
          <a href="#">
            <i className="fa fa-eye" />
            <span>Most Watched</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
  {/* Posts Filter Bar End */}
  {/* News Ticker Start */}
  <div className="news--ticker">
    <div className="container">
      <div className="title">
        <h2>News Updates</h2>
        <span>(Update 12 minutes ago)</span>
      </div>
      <div className="news-updates--list" data-marquee="true">
        <ul className="nav">
          <li>
            <h3 className="h3"><a href="#">Contrary to popular belief Lorem Ipsum is not simply random text.</a></h3>
          </li>
          <li>
            <h3 className="h3"><a href="#">Education to popular belief Lorem Ipsum is not simply</a></h3>
          </li>
          <li>
            <h3 className="h3"><a href="#">Lorem ipsum dolor sit amet consectetur adipisicing elit.</a></h3>
          </li>
          <li>
            <h3 className="h3"><a href="#">Corporis repellendus perspiciatis reprehenderit.</a></h3>
          </li>
          <li>
            <h3 className="h3"><a href="#">Deleniti consequatur laudantium sit aspernatur?</a></h3>
          </li>
        </ul>
      </div>
    </div>
  </div>
  {/* News Ticker End */}
  {/* Main Breadcrumb Start */}
  <div className="main--breadcrumb">
    <div className="container">
      <ul className="breadcrumb">
        <li><a href="home-1.html" className="btn-link"><i className="fa fm fa-home" />Home</a></li>
        <li className="active"><span>About</span></li>
      </ul>
    </div>
  </div>
  {/* Main Breadcrumb End */}
  {/* Main Content Section Start */}
  <div className="main-content--section pbottom--30">
    <div className="container">
      {/* Main Content Start */}
      <div className="main--content">
        {/* Post Item Start */}
        <div className="post--item post--single pd--30-0">
          <div className="row">
            <div className="col-md-6">
              <div className="post--video embed-responsive embed-responsive-16by9">
                <iframe src="https://www.youtube.com/embed/aqz-KE-bpKQ?rel=0&controls=0&showinfo=0&wmode=transparent" allowFullScreen />
              </div>
            </div>
            <div className="col-md-6">
              <div className="post--info">
                <div className="title">
                  <h2 className="h4">It is a long established fact that a reader will be distracted by the readable content</h2>
                </div>
              </div>
              <div className="post--content">
                <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal making it look like readable english many desktop.</p>
                <blockquote>
                  <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking.</p>
                  <footer>Semyaza, Australia</footer>
                </blockquote>
              </div>
            </div>
          </div>
        </div>
        {/* Post Item End */}
        {/* Info Blocks Start */}
        <div className="info--blocks ptop--30">
          <ul className="nav row">
            <li className="col-md-3 col-xs-6 col-xxs-12 pbottom--30">
              {/* Info Block Start */}
              <div className="info--block">
                <div className="icon text--color-1">
                  <i className="fa fa-dashboard" />
                </div>
                <div className="title">
                  <h3 className="h5">Our Goal</h3>
                </div>
                <div className="content">
                  <p>Aliquam quam laudantium suscipit ullam aut perferendis vel dicta blanditiis eligendi ratione consequatur, magni facilis dolor cupiditate et.</p>
                </div>
              </div>
              {/* Info Block End */}
            </li>
            <li className="col-md-3 col-xs-6 col-xxs-12 pbottom--30">
              {/* Info Block Start */}
              <div className="info--block">
                <div className="icon text--color-1">
                  <i className="fa fa-cog" />
                </div>
                <div className="title">
                  <h3 className="h5">Our Vission</h3>
                </div>
                <div className="content">
                  <p>Aliquam quam laudantium suscipit ullam aut perferendis vel dicta blanditiis eligendi ratione consequatur, magni facilis dolor cupiditate et.</p>
                </div>
              </div>
              {/* Info Block End */}
            </li>
            <li className="col-md-3 col-xs-6 col-xxs-12 pbottom--30">
              {/* Info Block Start */}
              <div className="info--block">
                <div className="icon text--color-1">
                  <i className="fa fa-diamond" />
                </div>
                <div className="title">
                  <h3 className="h5">Our Mission</h3>
                </div>
                <div className="content">
                  <p>Aliquam quam laudantium suscipit ullam aut perferendis vel dicta blanditiis eligendi ratione consequatur, magni facilis dolor cupiditate et.</p>
                </div>
              </div>
              {/* Info Block End */}
            </li>
            <li className="col-md-3 col-xs-6 col-xxs-12 pbottom--30">
              {/* Info Block Start */}
              <div className="info--block">
                <div className="icon text--color-1">
                  <i className="fa fa-object-group" />
                </div>
                <div className="title">
                  <h3 className="h5">Our Objectives</h3>
                </div>
                <div className="content">
                  <p>Aliquam quam laudantium suscipit ullam aut perferendis vel dicta blanditiis eligendi ratione consequatur, magni facilis dolor cupiditate et.</p>
                </div>
              </div>
              {/* Info Block End */}
            </li>
          </ul>
        </div>
        {/* Info Blocks End */}
      </div>
      {/* Main Content End */}
    </div>
  </div>
  {/* Main Content Section End */}
  {/* Counter Section Start */}
  <div className="counter--section">
    <div className="row gutter--0">
      <div className="col-md-3 col-xs-6 col-xxs-12">
        {/* Counter Item Start */}
        <div className="counter--item odd bg--color-1">
          <div className="icon">
            <i className="fa fa-trophy" />
          </div>
          <div className="text">
            <p>Awards</p>
          </div>
          <div className="num">
            <p><span data-trigger="counterUp">200</span></p>
          </div>
        </div>
        {/* Counter Item End */}
      </div>
      <div className="col-md-3 col-xs-6 col-xxs-12">
        {/* Counter Item Start */}
        <div className="counter--item even bg--color-1">
          <div className="icon">
            <i className="fa fa-users" />
          </div>
          <div className="text">
            <p>Global Team Members</p>
          </div>
          <div className="num">
            <p><span data-trigger="counterUp">600</span></p>
          </div>
        </div>
        {/* Counter Item End */}
      </div>
      <div className="col-md-3 col-xs-6 col-xxs-12">
        {/* Counter Item Start */}
        <div className="counter--item odd bg--color-1">
          <div className="icon">
            <i className="fa fa-copy" />
          </div>
          <div className="text">
            <p>Print Versions</p>
          </div>
          <div className="num">
            <p><span data-trigger="counterUp">8000</span></p>
          </div>
        </div>
        {/* Counter Item End */}
      </div>
      <div className="col-md-3 col-xs-6 col-xxs-12">
        {/* Counter Item Start */}
        <div className="counter--item even bg--color-1">
          <div className="icon">
            <i className="fa fa-smile-o" />
          </div>
          <div className="text">
            <p>Subscribes</p>
          </div>
          <div className="num">
            <p><span data-trigger="counterUp">2,000,000</span></p>
          </div>
        </div>
        {/* Counter Item End */}
      </div>
    </div>
  </div>
  {/* Counter Section End */}
  {/* Single Image Section Start */}
  <div className="single-img--section ptop--30">
    <div className="container">
      <img src="img/about-img/peoples.jpg" alt className="center-block" />
    </div>
  </div>
  {/* Single Image Section End */}
  {/* Back To Top Button Start */}
  <div id="backToTop">
    <a href="#"><i className="fa fa-angle-double-up" /></a>
  </div>
</div>

  );
};

export default About;